import { ListItemIcon, MenuItem, MenuList, Typography } from "@material-ui/core";
import { MenuItemsProps } from "components/menuItems/interfaces/menuItems";
import { useListItemIconStyles, useMenuItemsStyles, useMenuItemStyles } from "components/menuItems/styles";
import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router";
import { observer } from "mobx-react";
import { useRootStore } from "app/useRootStore";

const MenuItems: React.FC<MenuItemsProps> = ({ menuItems, isPopup, handleClose }: MenuItemsProps): JSX.Element => {
    const {
        rootStore: {
            layoutStore: { closeMenu },
        },
    } = useRootStore();
    const history = useHistory();
    const menuItemClasses = useMenuItemStyles({ isPopup });
    const listItemIconClasses = useListItemIconStyles({ isPopup });
    const classes = useMenuItemsStyles({ isPopup });
    const { pathname } = useLocation();
    const [selectedItem, setSelectedItem] = React.useState<number | null>(null);

    const handleMenuItemClick = (event: React.MouseEvent<HTMLElement>, index: number) => {
        if (menuItems[index].route) {
            history.push(menuItems[index].route!, menuItems[index].routeState);
        } else if (menuItems[index].onClick) {
            menuItems[index].onClick!();
        }

        if (handleClose) {
            handleClose(event);
        }

        closeMenu();
    };

    useEffect(() => {
        const index = menuItems.findIndex(
            menuItem =>
                menuItem.route !== "" &&
                (pathname.startsWith(`${menuItem.route}`) || pathname.startsWith(`/${menuItem.route}`))
        );
        setSelectedItem(index === -1 ? null : index);
    }, [pathname, menuItems]);

    return (
        <MenuList className={classes.root}>
            {menuItems.map((menuItem, index) =>
                menuItem.route || menuItem.onClick ? (
                    <MenuItem
                        key={menuItem.route}
                        selected={index === selectedItem}
                        onClick={(event: React.MouseEvent<HTMLElement>) => handleMenuItemClick(event, index)}
                        disableRipple
                        classes={{ ...menuItemClasses }}
                    >
                        {(menuItem.iconElement || menuItem.iconLink) && (
                            <ListItemIcon classes={{ ...listItemIconClasses }}>
                                {menuItem.iconElement ||
                                    (menuItem.iconLink && (
                                        <img className={classes.icon} src={menuItem.iconLink} alt={menuItem.name} />
                                    ))}
                            </ListItemIcon>
                        )}
                        <Typography variant={isPopup ? "body2" : "subtitle2"} className={classes.itemName} noWrap>
                            {menuItem.name}
                        </Typography>
                    </MenuItem>
                ) : (
                    <div key={menuItem.name} className={classes.separator}>
                        <Typography variant="overline" noWrap color="inherit">
                            {menuItem.name}
                        </Typography>
                    </div>
                )
            )}
        </MenuList>
    );
};

export default observer(MenuItems);
